import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";
import { K1DashboardProvider } from "@/features/K1Dashboard/context/K1DashboardProvider";
import PeFundsView from "@/features/K1Dashboard/views/PeFundsView";
import K1PeFundsEdit from "./edit";

export default function K1PeFunds() {
  useEffect(() => {
    setDocumentTitle("Quantilia | PE Funds");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<K1PeFundsEdit />} />
      <Route
        index
        element={
          <K1DashboardProvider>
            <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
              <PeFundsView />
            </main>
          </K1DashboardProvider>
        }
      />
    </Routes>
  );
}
